import { render, staticRenderFns } from "./AutorizacionTarjeta.vue?vue&type=template&id=08864c6c&scoped=true"
import script from "./AutorizacionTarjeta.vue?vue&type=script&lang=js"
export * from "./AutorizacionTarjeta.vue?vue&type=script&lang=js"
import style0 from "./AutorizacionTarjeta.vue?vue&type=style&index=0&id=08864c6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08864c6c",
  null
  
)

export default component.exports